import { api } from "./api";

const salesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSales: builder.query({
      query: () => "sales",
      providesTags: ["sales"],
    }),
    removeSales: builder.mutation({
      query: (id) => ({
        url: `sales/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["sales"],
    }),
  }),
});

export const { useGetSalesQuery, useRemoveSalesMutation } = salesApi;